import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const delayCountValidator: SchemaItem['x-validator'] = {
  validator(value: { allowDelay: boolean; delayTotalCount?: number }) {
    if (!value.allowDelay) {
      return null
    }

    if (isNil(value.delayTotalCount)) {
      return '延迟次数不能为空'
    }

    if (value.delayTotalCount <= 0) {
      return '延迟次数值必须大于0'
    }

    return null
  }
}
